import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';
import { initProductOptions } from '../ProductOptionsSelector';

export const selectSkuId = memoize((sourceMiniPDP = false) =>
    createSelector([initProductOptions(sourceMiniPDP)], (productOptions) => {
        if (
            productOptions &&
            productOptions.filteredItems &&
            productOptions.filteredItems.length === 1
        ) {
            return productOptions.filteredItems[0].id;
        }
        return null;
    })
);

export default {
    selectSkuId,
};
